import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { validateEmail, validateFullName } from '../../../formValidators';
import CompanyRegistrationDropdown from '../../common/CompanyRegistrationDropdown';
import StyledTextField from '../../common/StyledTextField';
import PasswordInput from '../../PasswordInput';
import SocialLoginForm from '../SocialLoginForm';
import { analyticsTrack } from '../../../analyticsUtils';
var renderAgreementLinks = function renderAgreementLinks() {
  return /*#__PURE__*/React.createElement("div", {
    className: "terms-and-privacy form-group body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "terms-and-privacy-label body-text-3 normal-weight"
  }, "By signing up, you agree to", /*#__PURE__*/React.createElement("a", {
    href: "/terms-of-use"
  }, " Clora's Terms of Use"), ",", /*#__PURE__*/React.createElement("a", {
    href: "/master_services_agreement"
  }, " Master Service Agreement"), ' ', "and", /*#__PURE__*/React.createElement("a", {
    href: "/privacy-policy"
  }, " Privacy Policy"), "."));
};
var EmployerSignupForm = /*#__PURE__*/function (_Component) {
  function EmployerSignupForm(props) {
    var _this;
    _classCallCheck(this, EmployerSignupForm);
    _this = _callSuper(this, EmployerSignupForm, [props]);
    _this.state = {
      email: props.invitedEmail || '',
      password: '',
      company: props.company || '',
      userName: props.userName || '',
      errors: {},
      submitted: false,
      showLocalRegistrationFields: false
    };
    _this.handleUpdateField = _this.handleUpdateField.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.toggleLocalRegistrationFields = _this.toggleLocalRegistrationFields.bind(_this);
    return _this;
  }
  _inherits(EmployerSignupForm, _Component);
  return _createClass(EmployerSignupForm, [{
    key: "toggleLocalRegistrationFields",
    value: function toggleLocalRegistrationFields() {
      var showLocalRegistrationFields = this.state.showLocalRegistrationFields;
      var location = this.props.location;
      analyticsTrack('Clicked continue during registration', {
        location: location
      });
      this.setState({
        showLocalRegistrationFields: !showLocalRegistrationFields
      });
    }
  }, {
    key: "handleValidate",
    value: function handleValidate() {
      var _this$state = this.state,
        email = _this$state.email,
        userName = _this$state.userName,
        password = _this$state.password,
        company = _this$state.company,
        errors = _this$state.errors;
      var fullNameValidation = validateFullName(userName);
      var emailValidation = validateEmail(email);
      this.setState({
        errors: _objectSpread(_objectSpread({}, errors), {}, {
          email: emailValidation.error,
          userName: fullNameValidation.error,
          password: password.length ? null : 'Please fill out this field.',
          company: company.length ? null : 'Please fill out this field.'
        })
      });
      return !emailValidation.error && fullNameValidation.isValid && password.length && company.length;
    }
  }, {
    key: "handleUpdateField",
    value: function handleUpdateField(field) {
      var _this2 = this;
      return function (e) {
        if (field === 'company') {
          _this2.setState({
            company: e.value
          });
        } else {
          _this2.setState(_defineProperty({}, field, e.target.value));
        }
      };
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.handleValidate()) {
        this.setState({
          submitted: true
        });
      } else {
        e.preventDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        invitedEmail = _this$props.invitedEmail,
        referralToken = _this$props.referralToken,
        submitButtonText = _this$props.submitButtonText,
        signInUrl = _this$props.signInUrl,
        location = _this$props.location,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        extraParams = _this$props.extraParams,
        inviterId = _this$props.inviterId,
        projectResourceId = _this$props.projectResourceId;
      var _this$state2 = this.state,
        userName = _this$state2.userName,
        company = _this$state2.company,
        email = _this$state2.email,
        errors = _this$state2.errors,
        submitted = _this$state2.submitted,
        showLocalRegistrationFields = _this$state2.showLocalRegistrationFields;
      return /*#__PURE__*/React.createElement("form", {
        id: "create_employer",
        action: "/registration/employers",
        acceptCharset: "UTF-8",
        method: "post",
        "data-turbo": "false",
        onSubmit: this.handleSubmit
      }, Object.keys(extraParams).map(function (key) {
        return /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: key,
          value: extraParams[key]
        });
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "authenticity_token",
        value: csrfToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "invited_email",
        value: invitedEmail
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "referral_token",
        value: referralToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "page_location",
        value: location
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "project_resource_id",
        value: projectResourceId
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "inviter_id",
        value: inviterId
      }), /*#__PURE__*/React.createElement(StyledTextField, {
        id: "email",
        className: "form-control fs-hide validate work-email",
        name: "user[email]",
        label: "Work Email",
        value: email,
        error: !!errors.email,
        helperText: errors.email,
        margin: "normal",
        onChange: this.handleUpdateField('email')
      }), showLocalRegistrationFields ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyledTextField, {
        id: "full_name",
        className: "form-control fs-hide mb-25",
        value: userName,
        error: !!errors.userName,
        helperText: errors.userName,
        onChange: this.handleUpdateField('userName'),
        name: "user[full_name]",
        label: "Full Name",
        type: "text",
        margin: "normal",
        autoFocus: true
      }), /*#__PURE__*/React.createElement(CompanyRegistrationDropdown, {
        error: errors.company,
        value: company,
        onChange: this.handleUpdateField('company')
      }), /*#__PURE__*/React.createElement(PasswordInput, {
        errors: errors.password,
        title: "Password",
        handleChange: this.handleUpdateField('password')
      }), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        name: "commit",
        id: "employer-sign-up-".concat(location),
        className: "btn btn-primary bigger-button full-width",
        disabled: submitted,
        onClick: function onClick() {
          return analyticsTrack('Clicked on sign up', {
            location: location
          });
        }
      }, submitButtonText))) : /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.toggleLocalRegistrationFields,
        className: "btn btn-primary bigger-button full-width mb-15"
      }, "Continue"), (googleOmniauthUrl || msOmniauthUrl) && /*#__PURE__*/React.createElement(SocialLoginForm, {
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        state: "register_employer",
        location: location
      })), renderAgreementLinks(), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight text-center log-in-links"
      }, "Already have a Clora account?\xA0", /*#__PURE__*/React.createElement("a", {
        className: "employer-registration-to-log-in-".concat(location, "  p-0"),
        href: signInUrl
      }, "Log in")));
    }
  }]);
}(Component);
EmployerSignupForm.propTypes = {
  userName: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  company: PropTypes.string,
  referralToken: PropTypes.string,
  submitButtonText: PropTypes.string,
  signInUrl: PropTypes.string.isRequired,
  location: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  extraParams: PropTypes.shape({}),
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string
};
EmployerSignupForm.defaultProps = {
  userName: '',
  invitedEmail: null,
  company: null,
  referralToken: null,
  submitButtonText: 'Sign Up as an Employer',
  location: 'registration',
  extraParams: {},
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  inviterId: null,
  projectResourceId: null
};
export default EmployerSignupForm;